<template>
  <breadcrumb :title="title" :subTitle="subTitle" :link="link" />
  <div class="container">
    <div class="row">
        <Sidebar />
        <Wishlist />
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/layouts/breadcrumb.vue";
import Sidebar from '@/components/layouts/sidebar.vue';
import Wishlist from '@/components/include/profile/wishlist/wishlist.vue';
export default {
  data() {
    return {
      title: this.$t("my_wishlist"),
      subTitle: "",
      link: "",
    };
  },
  components: { breadcrumb, Sidebar, Wishlist },
};
</script>

<style>
</style>